import PasswordResetFlow from './PasswordResetFlow';

export default PasswordResetFlow;
